import { useMemo } from 'react';
import { useActiveLots } from 'src/features/common/collectible/hooks/collectible.hooks';
import { useMyWalletsById } from 'src/features/common/wallet/hooks/use-my-wallets-by-id';

export const useActiveBuy = () => {
    const myWallets = useMyWalletsById();
    const activeLots = useActiveLots();

    return {
        isActiveLotsHasMyNft: useMemo(
            () => activeLots.length > 0 && activeLots.some((nft) => myWallets[nft.owner]),
            [activeLots, myWallets]
        ),
    };
};
